module.exports = __webpack_public_path__ + "img/logo-farmersMarketCoalition.b848048c.png";